import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "text-container" }
const _hoisted_3 = { class: "box gauge" }
const _hoisted_4 = { class: "mask" }

import TextBase from '@/design-system/atoms/TextBase.vue'
import { FormatOptions, formatter } from './AnalyticsDashboard/formatter'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

type Props = {
  value: number
  min?: number
  max?: number
  color?: string
  format?: FormatOptions
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GaugeBase',
  props: {
    value: {},
    min: { default: 0 },
    max: { default: 1 },
    color: { default: '#3f46d6' },
    format: { default: undefined }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "70157829": (_ctx.color)
}))

const props = __props

const value = computed(
  () =>
    (Math.min(Math.max(props.value, props.min), props.max) - props.min) / (props.max - props.min)
)

const transform = computed(() => `rotate(${value.value * 180}deg) translate3d(0, 0, 0)`)

const { locale } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TextBase, {
        text: _unref(formatter)(value.value, _unref(locale), _ctx.format),
        type: 'h3',
        format: _ctx.format
      }, null, 8, ["text", "format"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "semi-circle" }, null, -1)),
        _createElementVNode("div", {
          class: "semi-circle--mask",
          style: _normalizeStyle({ transform: transform.value })
        }, null, 4)
      ])
    ])
  ]))
}
}

})